import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export default ({ component: C, props: cProps, ...rest }) => (
  <Route {...rest} render={props => (
    cProps.auth.isUserSignedIn()
      ? <C {...props} {...cProps} />
        : <Redirect to={`/`} />
      // Currently we  do not have sso redirect handling implemented
      // : <Redirect to={`/login?redirect=${props.location.pathname}${props.location.search}`} />
  )}/>
);


// WEBPACK FOOTER //
// ./src/components/AuthenticatedRoute.js